export default function isImage(filename) {
	// TODO: re-add "webp" once related security issues have been patched:
	// https://blog.cloudflare.com/uncovering-the-hidden-webp-vulnerability-cve-2023-4863/
	return /\.(jpeg|jpg|gif|png)$/i.test(filename)
}
